/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import BigNumber from 'bignumber.js'
import useGetPriceData from 'hooks/useGetPriceData'
import { PriceApiResponse, PriceApiThunk, PriceState } from 'state/types'
import tokens from 'config/constants/tokens'
import { useRouterContract } from 'hooks/useContract'
import { DEFAULT_TOKEN_DECIMAL } from 'config'

const initialState: PriceState = {
  isLoading: false,
  lastUpdated: null,
  data: null,
}

// Thunks
export const fetchPrices = createAsyncThunk<PriceApiThunk>('prices/fetch', async () => {
  const response = await fetch('https://api.pancakeswap.info/api/v2/tokens')
  const data = (await response.json()) as PriceApiResponse

  const response2 = await fetch('https://api.pancakeswap.info/api/v2/tokens')
  const data2 = (await response2.json()) as PriceApiResponse

  // 获取pixel的数据
  try {
    const bnbPriceData = data.data[tokens.wbnb.address[process.env.REACT_APP_CHAIN_ID]]
    const pxfPriceData = data2.data[tokens.pxf.address[process.env.REACT_APP_CHAIN_ID]]
    const priceUsd = (bnbPriceData && pxfPriceData) ? Number(new BigNumber(bnbPriceData.price).times(new BigNumber(pxfPriceData.price_BNB)).toFixed(3)) : undefined
    data.data[tokens.pxf.address[process.env.REACT_APP_CHAIN_ID]] = Object.assign(pxfPriceData, { price: priceUsd })
  } catch (e) {
    // 
  }

  // Return normalized token names
  return {
    updated_at: data.updated_at,
    data: Object.keys(data.data).reduce((accum, token) => {
      return {
        ...accum,
        [token.toLowerCase()]: parseFloat(data.data[token].price),
      }
    }, {}),
  }
})

export const pricesSlice = createSlice({
  name: 'prices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchPrices.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(fetchPrices.fulfilled, (state, action: PayloadAction<PriceApiThunk>) => {
      state.isLoading = false
      state.lastUpdated = action.payload.updated_at
      state.data = action.payload.data
    })
  },
})

export default pricesSlice.reducer
